<template>
  <div class="read_newspapers_detail">
    <!-- <div v-title :data-title="titleShow"></div> -->
    <!-- <div class="back" @click="back()">
            <img src="../../../../public/image/back.png" alt="">
        </div> -->
    <p v-text="curDoc.introduction" class="intro_title"></p>
    <p v-text="curDoc.documentTitle" class="title"></p>
    <p class="sub_title" v-text="curDoc.subtitle"></p>
    <!-- <p class="reporter" v-if="curDoc.documentAuthor||curDoc.correspondent">
            <span class="author">作者：{{curDoc.documentAuthor}}</span>
            <span class="correspondent">通讯员:{{curDoc.correspondent}}</span>
        </p> -->
    <p class="time" v-if="curDoc.publishTime">
      <span v-text="formatDate(curDoc.publishTime, 'yyyy-MM-dd')"></span>
    </p>
    <template v-for="item in imgs">
      <div
        class="article_pic"
        v-if="imgs.length > 0"
        :key="item.layoutDetailId"
      >
        <img
          :src="imgAddressPrefix + item.simplePictureLink"
          alt=""
          v-if="item.simplePictureLink"
        />
        <p
          class="article_pic_title"
          v-text="item.caption"
          v-if="item.simplePictureLink && item.caption"
        ></p>
      </div>
    </template>
    <div
      class="content"
      v-html="handleHtmlContent(curDoc.documentContent)"
    ></div>
  </div>
</template>
<script>
import "trs-app-js-bridge";
export default {
  name: "readNewspapersDetail",
  data() {
    return {
      curDoc: "", //当前文章
      imgs: [], //文章里的图片
      imgAddressPrefix: "", // 图片访问前缀
      title: "",
    };
  },
  computed: {
    titleShow() {
      return this.title + "-" + this.curDoc.documentTitle;
    },
  },
  async mounted() {
    let self = this;
    this.title = this.$route.query.title;
    await this.requestDocDetail();
    document.title = self.curDoc.documentTitle;
    this.loadCPsdk(() => {
      this.setShare({
        docTitle: self.curDoc.documentTitle,
        content: self.getContent(self.curDoc.documentContent),
        docId: self.curDoc.layoutDetailId,
      });
    });
  },
  methods: {
    /**
     * [requestArticleDetail description]通過文章id获取文章详情
     * @param  {[type]} articleId [description]
     * @return {[type]}           [description]
     */
    requestDocDetail() {
      return new Promise((resolve) => {
        let self = this;
        const pictureDetail = this.$route.query.pictureDetail;
        let params = {
          layoutDetailId: this.$route.query.id,
          pictureDetail: pictureDetail ? pictureDetail : 0,
        };
        self
          .post(
            "/digitalNewspaper/web/layoutDetail/findByLayoutDetailId",
            params
          )
          .then((resp) => {
            try {
              self.curDoc = resp.msg;
              self.imgs = resp.layoutPictures;
              self.imgAddressPrefix = resp.addressPrefix;
              resolve();
            } catch (e) {}
          });
      });
    },
    /**
     * [back description]回退到上一个页面
     * @return {[type]} [description]
     */
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.read_newspapers_detail {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  padding: 20px 15px 80px;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }

  .back {
    position: fixed;
    left: 10px;
    bottom: 20px;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }

  .intro_title {
    font-size: 16px;
    font-weight: normal;
    color: rgba(42, 42, 42, 1);
    line-height: 30px;
    text-align: center;
  }

  .title {
    font-size: 24px;
    font-weight: normal;
    line-height: 40px;
    text-align: center;
  }

  .sub_title {
    font-size: 16px;
    font-weight: normal;
    line-height: 30px;
    color: rgba(42, 42, 42, 1);
    text-align: center;
  }

  .reporter {
    font-size: 12px;
    font-weight: normal;
    color: rgba(121, 121, 121, 1);
    line-height: 14px;
    margin-top: 12px;
    text-align: center;
  }

  .time {
    margin-bottom: 10px;
    color: rgba(121, 121, 121, 1);
    text-align: center;
  }

  .article_pic {
    width: 100%;
    text-align: center;

    img {
      max-width: 100%;
    }

    .article_pic_title {
      text-align: center;
    }
  }

  .content {
    box-sizing: border-box;
    width: 100%;
    color: #5b5c64;
    line-height: 30px;
    text-align: justify;
    font-size: 16px;
  }
}

@media screen and (min-width: 768px) {
  .read_newspapers_detail {
    padding-left: 20%;
    padding-right: 20%;
  }
}
</style>